/* ============================================================
   Melix Lab 头皮分析 — 画面与互动 (v2 双语)
   ★ 不要修改这个档案。要改文案 → melix-quiz-config.js
   ============================================================ */
(function (root) {
  "use strict";

  var CFG = root.MELIX_QUIZ_CONFIG;
  var E = root.MELIX_QUIZ_ENGINE;

  function init() {
    var mount = document.getElementById("melix-quiz");
    if (!mount || !CFG || !E) return;

    var params = new URLSearchParams(root.location.search);
    var state = {
      step: -1,
      answers: {},
      lang: (params.get("lang") === "zh" || params.get("lang") === "en")
        ? params.get("lang")
        : (CFG.DEFAULT_LANG || "en"),
      report: null
    };

    /* ---------- 语言解析: {en, zh} → 目前语言的字 ---------- */
    function t(v) {
      if (v && typeof v === "object" && (v.en !== undefined || v.zh !== undefined)) {
        return v[state.lang] !== undefined ? v[state.lang] : (v.en || v.zh || "");
      }
      return v === undefined || v === null ? "" : String(v);
    }

    function el(tag, cls, html) {
      var d = document.createElement(tag);
      if (cls) d.className = cls;
      if (html !== undefined) d.innerHTML = html;
      return d;
    }
    function esc(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
      });
    }
    function analysisBaseUrl() {
      var params = new URLSearchParams(root.location.search);
      var view = params.get("view");
      return root.location.pathname + (view ? "?view=" + encodeURIComponent(view) : "");
    }

    function pageUrl(code) {
      var base = analysisBaseUrl();
      var joiner = base.indexOf("?") >= 0 ? "&" : "?";
      return root.location.origin + base + joiner + "r=" + code + "&lang=" + state.lang;
    }
    function UI() { return CFG.COPY.ui; }

    var INDEX_COLORS = {
      oil: "#175BBE",
      blockage: "#175BBE",
      hydration: "#175BBE",
      flakes: "#175BBE",
      sensitivity: "#175BBE",
      overall: "#175BBE"
    };
    function indexColor(key) {
      return INDEX_COLORS[key] || INDEX_COLORS.overall;
    }
    function displayIndexScore(value) {
      var n = Number(value);
      if (!isFinite(n)) n = 0;
      return Math.min(10, Math.max(1, Math.round(n)));
    }

    /* ---------- 蜂窝雷达图 (6 轴: 5 指数 + 综合) ---------- */
    function radarSVG(scores) {
      var NS = "http://www.w3.org/2000/svg";
      var num = 0, den = 0;
      Object.keys(CFG.WEIGHTS).forEach(function (k) {
        num += (scores[k] || 0) * CFG.WEIGHTS[k];
        den += CFG.WEIGHTS[k];
      });
      var overall = Math.min(10, Math.max(0, Math.round(num / den)));
      var axes = CFG.INDEXES.map(function (ix) {
        return {
          key: ix.key,
          label: t(ix.short || ix.label),
          value: displayIndexScore(scores[ix.key]),
          color: indexColor(ix.key)
        };
      });
      axes.push({
        key: "overall",
        label: t(UI().overallShort),
        value: displayIndexScore(overall),
        color: indexColor("overall")
      });

      var W = 320, H = 292, cx = W / 2, cy = 142, R = 92;
      function pt(i, r) {
        var ang = -Math.PI / 2 + (i * 2 * Math.PI / axes.length);
        return [cx + r * Math.cos(ang), cy + r * Math.sin(ang)];
      }
      function ring(rr) {
        return axes.map(function (_, i) { return pt(i, rr).join(","); }).join(" ");
      }
      var svg = document.createElementNS(NS, "svg");
      svg.setAttribute("viewBox", "0 0 " + W + " " + H);
      svg.setAttribute("class", "mxq-radar");
      svg.setAttribute("role", "img");

      /* 蜂窝格线 (3 圈六角) */
      [R / 3, R * 2 / 3, R].forEach(function (rr, gi) {
        var poly = document.createElementNS(NS, "polygon");
        poly.setAttribute("points", ring(rr));
        poly.setAttribute("fill", gi === 2 ? "rgba(20,50,75,0.03)" : "none");
        poly.setAttribute("stroke", "#c9d6de");
        poly.setAttribute("stroke-width", gi === 2 ? "1.4" : "1");
        svg.appendChild(poly);
      });
      /* 轴线: 每个指数沿用自己的识别色 */
      axes.forEach(function (a, i) {
        var ln = document.createElementNS(NS, "line");
        var p = pt(i, R);
        ln.setAttribute("x1", cx); ln.setAttribute("y1", cy);
        ln.setAttribute("x2", p[0]); ln.setAttribute("y2", p[1]);
        ln.setAttribute("stroke", a.color);
        ln.setAttribute("stroke-opacity", "0.28");
        ln.setAttribute("stroke-width", "1.25");
        svg.appendChild(ln);
      });
      /* 资料多边形 */
      var dataPts = axes.map(function (a, i) { return pt(i, Math.max(0.06, a.value / 10) * R).join(","); }).join(" ");
      var dp = document.createElementNS(NS, "polygon");
      dp.setAttribute("points", dataPts);
      dp.setAttribute("fill", "rgba(23,91,190,0.14)");
      dp.setAttribute("stroke", "#175BBE");
      dp.setAttribute("stroke-width", "2");
      dp.setAttribute("stroke-linejoin", "round");
      svg.appendChild(dp);
      /* 顶点 + 数值 + 标签 */
      axes.forEach(function (a, i) {
        var p = pt(i, Math.max(0.06, a.value / 10) * R);
        var dot = document.createElementNS(NS, "circle");
        dot.setAttribute("cx", p[0]); dot.setAttribute("cy", p[1]);
        dot.setAttribute("r", "4");
        dot.setAttribute("fill", a.color);
        svg.appendChild(dot);

        var lp = pt(i, R + 22);
        var tx = document.createElementNS(NS, "text");
        tx.setAttribute("x", lp[0]); tx.setAttribute("y", lp[1] - 3);
        tx.setAttribute("text-anchor", "middle");
        tx.setAttribute("class", "mxq-radar-label");
        tx.style.fill = a.color;
        tx.textContent = a.label;
        svg.appendChild(tx);
        var tv = document.createElementNS(NS, "text");
        tv.setAttribute("x", lp[0]); tv.setAttribute("y", lp[1] + 11);
        tv.setAttribute("text-anchor", "middle");
        tv.setAttribute("class", "mxq-radar-val");
        tv.style.fill = a.color;
        tv.textContent = a.value + "/10";
        svg.appendChild(tv);
      });
      return svg;
    }

    function levelOf(v) {
      return v >= 7 ? { key: "high", label: t(UI().levelHigh) }
           : v >= 4 ? { key: "mid",  label: t(UI().levelMid) }
                    : { key: "low",  label: t(UI().levelLow) };
    }

    /* ---------- 语言切换钮 (每个画面右上角) ---------- */
    function langToggle(rerender) {
      var wrap = el("div", "mxq-lang");
      ["en", "zh"].forEach(function (L) {
        var b = el("button", "mxq-lang-btn" + (state.lang === L ? " is-on" : ""), L === "en" ? "EN" : "中文");
        b.type = "button";
        b.addEventListener("click", function () {
          if (state.lang === L) return;
          state.lang = L;
          rerender();
        });
        wrap.appendChild(b);
      });
      return wrap;
    }

    /* ---------- 画面: 开始页 ---------- */
    function renderIntro() {
      mount.innerHTML = "";
      var box = el("div", "mxq-card mxq-intro");
      box.appendChild(langToggle(renderIntro));
      box.appendChild(el("div", "mxq-eyebrow", "Melix Lab"));
      box.appendChild(el("h2", "mxq-title", esc(t(UI().introTitle))));
      box.appendChild(el("p", "mxq-sub", esc(t(UI().introSub))));
      var btn = el("button", "mxq-btn mxq-btn-primary", esc(t(UI().introBtn)));
      btn.type = "button";
      btn.addEventListener("click", function () {
        E.track("quiz_start", { lang: state.lang });
        state.step = 0;
        renderQuestion();
      });
      box.appendChild(btn);
      mount.appendChild(box);
    }

    /* ---------- 画面: 题目 ---------- */
    function renderQuestion() {
      var qi = state.step;
      var q = CFG.QUESTIONS[qi];
      mount.innerHTML = "";

      var box = el("div", "mxq-card");
      box.appendChild(langToggle(renderQuestion));

      var progWrap = el("div", "mxq-progress");
      var progBar = el("div", "mxq-progress-bar");
      progBar.style.width = Math.round(((qi + 1) / CFG.QUESTIONS.length) * 100) + "%";
      progWrap.appendChild(progBar);
      box.appendChild(progWrap);
      box.appendChild(el("div", "mxq-progress-label", (qi + 1) + " / " + CFG.QUESTIONS.length));

      box.appendChild(el("h3", "mxq-q-title", esc(t(q.title))));
      if (q.subtitle) box.appendChild(el("p", "mxq-q-sub", esc(t(q.subtitle))));

      var list = el("div", "mxq-options");

      if (q.type === "single") {
        q.options.forEach(function (o, i) {
          var b = el("button", "mxq-opt" + (state.answers[q.id] === i ? " is-selected" : ""), esc(t(o.label)));
          b.type = "button";
          b.addEventListener("click", function () {
            state.answers[q.id] = i;
            b.classList.add("is-selected");
            setTimeout(next, 160);
          });
          list.appendChild(b);
        });
      } else {
        /* 多选 = checkbox 样式, 勾选状态一目了然 */
        var cur = Array.isArray(state.answers[q.id]) ? state.answers[q.id].slice() : [];

        q.options.forEach(function (o, i) {
          var sel = o.none
            ? (cur.length === 0 && state.answers[q.id] !== undefined)
            : cur.indexOf(i) >= 0;
          var b = el("button", "mxq-opt mxq-opt-check" + (sel ? " is-selected" : ""),
            '<span class="mxq-checkbox" aria-hidden="true"></span><span class="mxq-check-label">' + esc(t(o.label)) + "</span>");
          b.type = "button";
          b.setAttribute("role", "checkbox");
          b.setAttribute("aria-checked", sel ? "true" : "false");
          b.addEventListener("click", function () {
            if (o.none) {
              /* 「都没有」= 清空 + 直接跳下一题 */
              state.answers[q.id] = [];
              b.classList.add("is-selected");
              setTimeout(next, 200);
            } else {
              var at = cur.indexOf(i);
              if (at >= 0) cur.splice(at, 1); else cur.push(i);
              state.answers[q.id] = cur.slice();
              renderQuestion();
            }
          });
          list.appendChild(b);
        });
      }
      box.appendChild(list);

      var nav = el("div", "mxq-nav");
      if (qi > 0) {
        var back = el("button", "mxq-btn mxq-btn-ghost", esc(t(UI().backBtn)));
        back.type = "button";
        back.addEventListener("click", function () { state.step--; renderQuestion(); });
        nav.appendChild(back);
      }
      if (q.type === "multi") {
        var nextBtn = el("button", "mxq-btn mxq-btn-primary", esc(t(UI().nextBtn)));
        nextBtn.type = "button";
        nextBtn.addEventListener("click", function () {
          if (state.answers[q.id] === undefined) state.answers[q.id] = [];
          next();
        });
        nav.appendChild(nextBtn);
      }
      box.appendChild(nav);
      mount.appendChild(box);
      root.scrollTo && root.scrollTo({ top: mount.offsetTop - 20, behavior: "auto" });
    }

    function next() {
      if (state.step < CFG.QUESTIONS.length - 1) {
        state.step++;
        renderQuestion();
      } else {
        finishQuiz();
      }
    }

    function finishQuiz() {
      CFG.QUESTIONS.forEach(function (q) {
        if (q.type === "multi" && state.answers[q.id] === undefined) state.answers[q.id] = [];
      });
      var report = E.buildReport(state.answers);
      E.track("quiz_complete", { scalp_type: report.scalpType, health: report.health, activate_type: report.recommendation.activate ? report.recommendation.activate.type : "none", lang: state.lang });
      E.saveReport(report);
      try { history.replaceState(null, "", pageUrl(report.code)); } catch (e) {}
      state.report = report;
      renderReport();
    }

    /* ---------- 画面: 报告 ---------- */
    function renderReport() {
      var r = state.report;
      state.step = "report";
      mount.innerHTML = "";
      var url = pageUrl(r.code);
      try { history.replaceState(null, "", url); } catch (e) {}

      var box = el("div", "mxq-report");

      /* 头 */
      var head = el("div", "mxq-card mxq-r-head");
      head.appendChild(langToggle(renderReport));
      head.appendChild(el("div", "mxq-eyebrow", "Melix Lab · " + esc(t(UI().resultTitle))));
      head.appendChild(el("div", "mxq-type-chip", esc(t(CFG.COPY.typeName[r.scalpType]) || r.scalpType)));
      head.appendChild(el("p", "mxq-type-intro", esc(t(r.typeIntro))));
      var healthRow = el("div", "mxq-health");
      healthRow.appendChild(el("div", "mxq-health-num", esc(String(r.health)) + "<span>/10</span>"));
      healthRow.appendChild(el("div", "mxq-health-label", esc(t(UI().healthLabel))));
      head.appendChild(healthRow);
      box.appendChild(head);

      /* 头皮与头发状态：五维头皮图 + 两项头发困扰 */
      var radarCard = el("div", "mxq-card mxq-radar-card");
      radarCard.appendChild(el("h3", "mxq-h", esc(t(UI().radarTitle))));
      radarCard.appendChild(el("div", "mxq-singles-title", esc(t(UI().scalpMapTitle))));
      radarCard.appendChild(radarSVG(r.scores));
      var hairTitle = el("div", "mxq-singles-title", esc(t(UI().hairConcernTitle)));
      hairTitle.style.marginTop = "18px";
      radarCard.appendChild(hairTitle);
      [
        { key: "hairFall", label: UI().hairFallLabel },
        { key: "hairVolume", label: UI().hairVolumeLabel }
      ].forEach(function (item) {
        var value = r.hairConcerns[item.key];
        var row = el("div", "mxq-bar-row");
        var top = el("div", "mxq-bar-top");
        top.appendChild(el("span", "mxq-bar-name", esc(t(item.label))));
        top.appendChild(el("span", "mxq-bar-val", value + "/10"));
        row.appendChild(top);
        var track = el("div", "mxq-bar-track");
        var fill = el("div", "mxq-bar-fill");
        fill.style.width = "0%";
        fill.style.backgroundColor = "#175bbe";
        track.appendChild(fill);
        row.appendChild(track);
        radarCard.appendChild(row);
        setTimeout(function () { fill.style.width = (value * 10) + "%"; }, 80);
      });
      radarCard.appendChild(el("p", "mxq-note", esc(t(UI().hairConcernNote))));
      radarCard.appendChild(el("p", "mxq-share-prompt", esc(t(UI().sharePrompt))));
      box.appendChild(radarCard);

      /* 指数 bars */
      var bars = el("div", "mxq-card");
      CFG.INDEXES.forEach(function (ix) {
        var v = displayIndexScore(r.scores[ix.key]);
        var row = el("div", "mxq-bar-row");
        var top = el("div", "mxq-bar-top");
        top.appendChild(el("span", "mxq-bar-name", esc(t(ix.label))));
        top.appendChild(el("span", "mxq-bar-val", v + "/10"));
        row.appendChild(top);
        var track = el("div", "mxq-bar-track");
        var fill = el("div", "mxq-bar-fill" + (v >= 6 ? " is-high" : ""));
        fill.style.width = "0%";
        fill.style.backgroundColor = indexColor(ix.key);
        track.appendChild(fill);
        row.appendChild(track);
        bars.appendChild(row);
        setTimeout(function () { fill.style.width = (v * 10) + "%"; }, 60);
      });
      box.appendChild(bars);

      /* 分析 */
      var ana = el("div", "mxq-card");
      ana.appendChild(el("h3", "mxq-h", esc(t(UI().analysisTitle))));
      ana.appendChild(el("p", "mxq-p", esc(t(r.analysis))));
      r.concernNotes.forEach(function (n) {
        ana.appendChild(el("p", "mxq-note", esc(t(n))));
      });
      box.appendChild(ana);

      /* Routine: 产品图 + 功效 bar */
      var rt = el("div", "mxq-card");
      rt.appendChild(el("h3", "mxq-h", esc(t(UI().routineTitle))));
      r.recommendation.products.forEach(function (p) {
        var card = el("div", "mxq-product");

        var grid = el("div", "mxq-product-grid");
        if (p.img) {
          var imgWrap = el("div", "mxq-product-img");
          var img = document.createElement("img");
          img.src = p.img;
          img.alt = p.name;
          img.loading = "lazy";
          if (p.versionKey === "activate") {
            img.style.objectFit = "cover";
            img.style.objectPosition = "center 60%";
            img.style.transform = "scale(1.35)";
          }
          img.onerror = function () { imgWrap.style.display = "none"; };
          imgWrap.appendChild(img);
          grid.appendChild(imgWrap);
        }

        var info = el("div", "mxq-product-info");
        var head2 = el("div", "mxq-product-head");
        head2.appendChild(el("span", "mxq-step", esc(p.step)));
        head2.appendChild(el("span", "mxq-pname", esc(p.name) + " <em>" + esc(p.size) + "</em>"));
        info.appendChild(head2);
        var vl = t(p.versionLabel);
        if (vl) info.appendChild(el("div", "mxq-version", esc(vl)));
        var rs = t(p.reason);
        if (rs) info.appendChild(el("p", "mxq-reason", esc(rs)));
        info.appendChild(el("div", "mxq-freq", esc(t(UI().freqLabel)) + "：<strong>" + esc(t(p.frequency)) + "</strong>"));
        grid.appendChild(info);
        card.appendChild(grid);

        /* 功效 bar (/5) */
        if (p.attrs && p.attrs.length) {
          var at = el("div", "mxq-attrs");
          p.attrs.forEach(function (a) {
            var arow = el("div", "mxq-attr");
            arow.appendChild(el("span", "mxq-attr-name", esc(t(a.label))));
            var atrack = el("div", "mxq-attr-track");
            var afill = el("div", "mxq-attr-fill");
            afill.style.width = "0%";
            atrack.appendChild(afill);
            arow.appendChild(atrack);
            arow.appendChild(el("span", "mxq-attr-val", a.value + "/5"));
            at.appendChild(arow);
            setTimeout(function () { afill.style.width = (a.value * 20) + "%"; }, 120);
          });
          card.appendChild(at);
        }

        rt.appendChild(card);
      });
      box.appendChild(rt);

      /* FAQ */
      var faq = el("div", "mxq-card");
      faq.appendChild(el("h3", "mxq-h", esc(t(UI().faqTitle))));
      CFG.COPY.faq.forEach(function (f) {
        var d = el("details", "mxq-faq");
        var s = el("summary", "", esc(t(f.q)));
        d.appendChild(s);
        d.appendChild(el("p", "mxq-p", esc(t(f.a))));
        faq.appendChild(d);
      });
      box.appendChild(faq);

      /* 顾客评价轮播 (同类型优先) */
      if (CFG.REVIEWS && CFG.REVIEWS.length) {
        var rv = el("div", "mxq-card");
        rv.appendChild(el("h3", "mxq-h", esc(t(UI().reviewsTitle))));
        var sorted = CFG.REVIEWS.slice().sort(function (a, b) {
          return (a.type === r.scalpType ? 0 : 1) - (b.type === r.scalpType ? 0 : 1);
        });
        var reviewViewport = el("div", "mxq-review-viewport");
        var reviewTrack = el("div", "mxq-review-track");
        sorted.forEach(function (rev) {
          var card = el("article", "mxq-review");
          card.setAttribute("aria-label", state.lang === "zh" ? "顾客反馈" : "Customer feedback");
          var head3 = el("div", "mxq-review-head");
          if (typeof rev.stars === "number" && rev.stars > 0) {
            var stars = "";
            for (var s = 0; s < 5; s++) stars += s < rev.stars ? "★" : "☆";
            head3.appendChild(el("span", "mxq-stars", stars));
          }
          head3.appendChild(el("span", "mxq-review-name", esc(t(rev.name) || "")));
          var tn = CFG.COPY.typeName[rev.type];
          if (tn) head3.appendChild(el("span", "mxq-review-tag", esc(t(tn))));
          if (rev.source) head3.appendChild(el("span", "mxq-review-tag", esc(t(rev.source))));
          card.appendChild(head3);
          card.appendChild(el("p", "mxq-p", esc(t(rev.text))));
          reviewTrack.appendChild(card);
        });
        reviewViewport.appendChild(reviewTrack);
        rv.appendChild(reviewViewport);

        if (sorted.length > 1) {
          var reviewIndex = 0;
          function goToReview(nextIndex) {
            reviewIndex = (nextIndex + sorted.length) % sorted.length;
            var targetReview = reviewTrack.children[reviewIndex];
            if (targetReview) {
              reviewViewport.scrollTo({
                left: targetReview.offsetLeft - reviewTrack.offsetLeft,
                behavior: "smooth"
              });
            }
          }
          var reduceReviewMotion = root.matchMedia &&
            root.matchMedia("(prefers-reduced-motion: reduce)").matches;
          var reviewAutoplayTimer = null;
          function stopReviewAutoplay() {
            if (reviewAutoplayTimer) {
              root.clearInterval(reviewAutoplayTimer);
              reviewAutoplayTimer = null;
            }
          }
          function startReviewAutoplay() {
            stopReviewAutoplay();
            if (reduceReviewMotion) return;
            reviewAutoplayTimer = root.setInterval(function () {
              if (!reviewViewport.isConnected) {
                stopReviewAutoplay();
                return;
              }
              goToReview(reviewIndex + 1);
            }, 4500);
          }
          reviewViewport.addEventListener("mouseenter", stopReviewAutoplay);
          reviewViewport.addEventListener("mouseleave", startReviewAutoplay);
          reviewViewport.addEventListener("focusin", stopReviewAutoplay);
          reviewViewport.addEventListener("focusout", startReviewAutoplay);
          reviewViewport.addEventListener("touchstart", stopReviewAutoplay, { passive: true });
          reviewViewport.addEventListener("touchend", startReviewAutoplay, { passive: true });

          var reviewScrollTimer;
          reviewViewport.addEventListener("scroll", function () {
            root.clearTimeout(reviewScrollTimer);
            reviewScrollTimer = root.setTimeout(function () {
              var width = reviewViewport.clientWidth || 1;
              reviewIndex = Math.max(0, Math.min(sorted.length - 1, Math.round(reviewViewport.scrollLeft / width)));
            }, 80);
          });
          startReviewAutoplay();
        }
        box.appendChild(rv);
      }

      /* 一个整合购买模块：一次加入完整配对 Routine */
      var buy = el("div", "mxq-card mxq-buy");
      var purchase = r.recommendation.purchase;
      var setCard = el("div", "mxq-set");
      setCard.appendChild(el("div", "mxq-badge", esc(t(CFG.SET.badge))));
      if (purchase.img) {
        var setImg = document.createElement("img");
        setImg.src = purchase.img;
        setImg.alt = t(purchase.name);
        setImg.loading = "lazy";
        setImg.className = "mxq-set-img";
        setImg.onerror = function () { setImg.style.display = "none"; };
        setCard.appendChild(setImg);
      }
      setCard.appendChild(el("h3", "mxq-set-name", esc(t(purchase.name))));
      setCard.appendChild(el("p", "mxq-set-contents",
        "<strong>" + esc(t(UI().matchedContents)) + "</strong> " + esc(t(purchase.contents))));
      var priceRow = el("div", "mxq-price-row");
      priceRow.appendChild(el("span", "mxq-price", "RM" + purchase.price));
      if (purchase.comparePrice) priceRow.appendChild(el("span", "mxq-compare", "RM" + purchase.comparePrice));
      if (purchase.saveAmount) {
        priceRow.appendChild(el("span", "mxq-save", esc(t(UI().setSaveNote).replace("{amount}", purchase.saveAmount))));
      }
      setCard.appendChild(priceRow);
      function doAddSet(btn) {
        btn.disabled = true;
        var old = btn.textContent;
        btn.textContent = "…";
        E.track("add_to_cart_complete_routine", {
          purchase_type: purchase.type,
          variants: purchase.variantIds.join(","),
          scalp_type: r.scalpType
        });
        addItemsToCart(purchase.variantIds).then(function (okay) {
          if (okay) { root.location.href = "/cart?view=melix-lab"; }
          else {
            btn.disabled = false;
            btn.textContent = old;
            alert(state.lang === "zh" ? "加入购物车失败，请再试一次" : "Couldn't add to cart, please try again");
          }
        });
      }
      var setBtn = el("button", "mxq-btn mxq-btn-primary mxq-btn-big", esc(t(UI().setBtn)));
      setBtn.type = "button";
      setBtn.addEventListener("click", function () { doAddSet(setBtn); });
      setCard.appendChild(setBtn);
      setCard.appendChild(el("p", "mxq-gift", esc(t(UI().giftNote))));
      buy.appendChild(setCard);

      buy.appendChild(el("p", "mxq-singles-title", esc(t(UI().singlesTitle))));
      var singles = el("div", "mxq-singles");
      r.recommendation.products.forEach(function (p) {
        var c = el("div", "mxq-single");
        if (p.img) {
          var si = document.createElement("img");
          si.src = p.img;
          si.alt = p.name;
          si.loading = "lazy";
          si.className = "mxq-single-img";
          si.onerror = function () { si.style.display = "none"; };
          c.appendChild(si);
        }
        var mid = el("div", "mxq-single-mid");
        mid.appendChild(el("div", "mxq-single-name", esc(p.step) + " " + esc(p.name)));
        var vl = t(p.versionLabel);
        mid.appendChild(el("div", "mxq-single-meta", esc(p.size) + (vl ? " · " + esc(vl) : "")));
        mid.appendChild(el("div", "mxq-single-price", "RM" + p.price));
        c.appendChild(mid);
        var b = el("button", "mxq-btn mxq-btn-outline", esc(t(UI().singleBtn)));
        b.type = "button";
        b.addEventListener("click", function () {
          b.disabled = true;
          E.track("add_to_cart_single", { product: p.id, variant: p.variantId });
          addToCart(p.variantId).then(function (okay) {
            if (okay) {
              b.textContent = t(UI().singleAdded);
              b.classList.add("is-added");
              viewCart.style.display = "block";
            } else {
              b.disabled = false;
              alert(state.lang === "zh" ? "加入购物车失败，请再试一次" : "Couldn't add to cart, please try again");
            }
          });
        });
        c.appendChild(b);
        singles.appendChild(c);
      });
      buy.appendChild(singles);

      var viewCart = el("a", "mxq-viewcart", esc(t(UI().viewCart)));
      viewCart.href = "/cart?view=melix-lab";
      viewCart.style.display = "none";
      buy.appendChild(viewCart);

      var cs = el("a", "mxq-cs mxq-btn mxq-btn-wa", '<svg class="mxq-wa-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1-.2.2-.7.8-.8 1-.1.2-.3.2-.5.1-.2-.1-1-.4-2-1.2-.7-.7-1.2-1.5-1.4-1.7-.1-.2 0-.4.1-.5l.4-.5c.1-.2.2-.3.3-.5 0-.2 0-.4-.1-.5l-.8-1.9c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.5.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.5 1 2.7c.1.2 1.8 2.8 4.4 3.9.6.3 1.1.4 1.5.5.6.2 1.2.2 1.6.1.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.2-.2-.4-.3z"/></svg>' + "<span>" + esc(t(UI().csNote)) + "</span>");
      cs.href = E.whatsappLink("ask", r.code, url, state.lang);
      cs.setAttribute("data-melix-report-whatsapp", "true");
      cs.target = "_blank";
      cs.rel = "noopener";
      buy.appendChild(cs);
      box.appendChild(buy);

      /* 页脚 */
      var foot = el("div", "mxq-foot");
      var restart = el("button", "mxq-btn mxq-btn-ghost", esc(t(UI().restartBtn)));
      restart.type = "button";
      restart.addEventListener("click", function () {
        state.answers = {};
        state.report = null;
        try { history.replaceState(null, "", analysisBaseUrl()); } catch (e) {}
        state.step = -1;
        renderIntro();
      });
      foot.appendChild(restart);
      var copyBtn = el("button", "mxq-btn mxq-btn-ghost mxq-copy", esc(t(UI().copyLink)));
      copyBtn.type = "button";
      copyBtn.addEventListener("click", function () {
        var link = pageUrl(r.code);
        function done() { copyBtn.textContent = t(UI().copied); }
        if (root.navigator && root.navigator.clipboard && root.navigator.clipboard.writeText) {
          root.navigator.clipboard.writeText(link).then(done, done);
        } else {
          try {
            var ta = document.createElement("textarea");
            ta.value = link;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand && document.execCommand("copy");
            document.body.removeChild(ta);
          } catch (e) {}
          done();
        }
      });
      foot.appendChild(copyBtn);
      var printLink = el("a", "mxq-btn mxq-btn-ghost", esc(t(UI().printBtn)));
      printLink.href = pageUrl(r.code) + "&print=1";
      printLink.target = "_blank";
      printLink.rel = "noopener";
      foot.appendChild(printLink);
      foot.appendChild(el("span", "mxq-code", esc(t(UI().reportCodeLabel)) + "：" + esc(r.code)));
      box.appendChild(foot);

      mount.appendChild(box);

      /* 底部悬浮购买条: 报告很长, 让购买永远一指可达 */
      var sticky = el("div", "mxq-sticky");
      var stickyInfo = el("div", "mxq-sticky-info",
        "<strong>RM" + purchase.price + "</strong><span>" + esc(t(CFG.SET.badge)) + " · " + (purchase.type === "none" ? "01–03" : "01–04") + "</span>");
      sticky.appendChild(stickyInfo);
      var stickyBtn = el("button", "mxq-btn mxq-btn-primary", esc(t(UI().setBtn)));
      stickyBtn.type = "button";
      stickyBtn.addEventListener("click", function () { doAddSet(stickyBtn); });
      sticky.appendChild(stickyBtn);
      mount.appendChild(sticky);

      /* 购买区进入画面时隐藏悬浮条 */
      if (typeof root.IntersectionObserver === "function") {
        var io = new root.IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            sticky.classList.toggle("is-hidden", en.isIntersecting);
          });
        }, { threshold: 0.15 });
        io.observe(buy);
      }

      root.scrollTo && root.scrollTo({ top: mount.offsetTop - 20, behavior: "auto" });
    }

    /* ---------- 画面: 打印版完整报告 (客服用, ?r=...&print=1) ---------- */
    function renderPrint(r) {
      state.step = "print";
      mount.innerHTML = "";

      var page = el("div", "mxq-print");

      /* 不打印的工具列 */
      var tools = el("div", "mxq-noprint mxq-print-tools");
      tools.appendChild(langToggle(function () { renderPrint(r); }));
      var pbtn = el("button", "mxq-btn mxq-btn-primary", esc(t(UI().printBtn)));
      pbtn.type = "button";
      pbtn.addEventListener("click", function () { root.print && root.print(); });
      tools.appendChild(pbtn);
      page.appendChild(tools);

      /* ===== 报告表头 (健康报告格式) ===== */
      var head = el("div", "mxq-print-head");
      var brandRow = el("div", "mxq-print-brandrow");
      brandRow.appendChild(el("div", "mxq-print-brand", "Melix Lab"));
      brandRow.appendChild(el("div", "mxq-hexdeco",
        '<svg viewBox="0 0 84 30" aria-hidden="true">' +
        '<polygon points="15,3 25,9 25,21 15,27 5,21 5,9" fill="none" stroke="#14324b" stroke-width="1.4" opacity="0.85"/>' +
        '<polygon points="42,3 52,9 52,21 42,27 32,21 32,9" fill="#dde9e4" stroke="#14324b" stroke-width="1.4"/>' +
        '<polygon points="69,3 79,9 79,21 69,27 59,21 59,9" fill="none" stroke="#14324b" stroke-width="1.4" opacity="0.5"/>' +
        "</svg>"));
      head.appendChild(brandRow);
      head.appendChild(el("h1", "mxq-print-title", esc(t(UI().printTitle))));
      page.appendChild(head);

      /* 报告资讯栏 (像检验单的基本资料格) */
      var today = new Date();
      var ds = today.getFullYear() + "-" + String(today.getMonth() + 1).padStart(2, "0") + "-" + String(today.getDate()).padStart(2, "0");
      var meta = el("div", "mxq-print-metagrid");
      [
        [t(UI().reportCodeLabel), r.code],
        [t(UI().printDate), ds],
        [t(UI().printAssessLabel), t(UI().printAssess)],
        [t(UI().resultTitle), t(CFG.COPY.typeName[r.scalpType]) || r.scalpType]
      ].forEach(function (pair) {
        var cell = el("div", "mxq-print-metacell");
        cell.appendChild(el("div", "mxq-print-metak", esc(pair[0])));
        cell.appendChild(el("div", "mxq-print-metav", esc(pair[1])));
        meta.appendChild(cell);
      });
      page.appendChild(meta);

      /* 01 头皮概况: 类型 + 健康指数 + 蜂窝图 */
      var sec1 = el("div", "mxq-print-sec");
      sec1.appendChild(el("h2", "mxq-print-h", "<span class=\"mxq-secno\">01</span>" + esc(t(UI().radarTitle))));
      var top = el("div", "mxq-print-top");
      var typeBox = el("div", "mxq-print-typebox");
      typeBox.appendChild(el("div", "mxq-type-chip", esc(t(CFG.COPY.typeName[r.scalpType]) || r.scalpType)));
      typeBox.appendChild(el("p", "mxq-p", esc(t(r.typeIntro))));
      var hBox = el("div", "mxq-print-health");
      hBox.appendChild(el("div", "mxq-health-num", esc(String(r.health)) + "<span>/10</span>"));
      hBox.appendChild(el("div", "mxq-print-label", esc(t(UI().healthLabel))));
      typeBox.appendChild(hBox);
      top.appendChild(typeBox);
      var radarWrap = el("div", "mxq-print-radar");
      radarWrap.appendChild(radarSVG(r.scores));
      top.appendChild(radarWrap);
      sec1.appendChild(top);
      page.appendChild(sec1);

      /* 02 检测项目表 (检验单格式: 项目 | 分数 | 等级 | 判读) */
      var ix = el("div", "mxq-print-sec");
      ix.appendChild(el("h2", "mxq-print-h", "<span class=\"mxq-secno\">02</span>" + esc(t(UI().printIndexTitle))));
      var table = el("table", "mxq-lab-table");
      var thead = el("thead", "", "<tr><th>" + esc(t(UI().thItem)) + "</th><th>" + esc(t(UI().thScore)) + "</th><th>" + esc(t(UI().thLevel)) + "</th><th>" + esc(t(UI().thNote)) + "</th></tr>");
      table.appendChild(thead);
      var tbody = el("tbody");
      CFG.INDEXES.forEach(function (m) {
        var v = displayIndexScore(r.scores[m.key]);
        var lv = levelOf(v);
        var note = CFG.COPY.indexNotes && CFG.COPY.indexNotes[m.key] ? t(CFG.COPY.indexNotes[m.key][lv.key]) : "";
        var tr = el("tr");
        tr.appendChild(el("td", "mxq-lab-item", esc(t(m.label))));
        tr.appendChild(el("td", "mxq-lab-score", esc(String(v)) + "<span>/10</span>"));
        tr.appendChild(el("td", "", "<span class=\"mxq-lab-flag is-" + lv.key + "\">" + esc(lv.label) + "</span>"));
        tr.appendChild(el("td", "mxq-lab-note", esc(note)));
        tbody.appendChild(tr);
      });
      [
        { key: "hairFall", label: UI().hairFallLabel },
        { key: "hairVolume", label: UI().hairVolumeLabel }
      ].forEach(function (m) {
        var v = r.hairConcerns[m.key];
        var lv = levelOf(v);
        var tr = el("tr");
        tr.appendChild(el("td", "mxq-lab-item", esc(t(m.label))));
        tr.appendChild(el("td", "mxq-lab-score", esc(String(v)) + "<span>/10</span>"));
        tr.appendChild(el("td", "", "<span class=\"mxq-lab-flag is-" + lv.key + "\">" + esc(lv.label) + "</span>"));
        tr.appendChild(el("td", "mxq-lab-note", esc(t(UI().hairConcernNote))));
        tbody.appendChild(tr);
      });
      table.appendChild(tbody);
      ix.appendChild(table);
      page.appendChild(ix);

      /* 03 分析 */
      var ana = el("div", "mxq-print-sec");
      ana.appendChild(el("h2", "mxq-print-h", "<span class=\"mxq-secno\">03</span>" + esc(t(UI().analysisTitle))));
      ana.appendChild(el("p", "mxq-p", esc(t(r.analysis))));
      r.concernNotes.forEach(function (n) { ana.appendChild(el("p", "mxq-note", esc(t(n)))); });
      page.appendChild(ana);

      /* Routine */
      var rt = el("div", "mxq-print-sec");
      rt.appendChild(el("h2", "mxq-print-h", "<span class=\"mxq-secno\">04</span>" + esc(t(UI().routineTitle))));
      r.recommendation.products.forEach(function (p) {
        var card = el("div", "mxq-print-prod");
        var vl = t(p.versionLabel);
        card.appendChild(el("div", "mxq-print-prod-name",
          "<strong>" + esc(p.step) + " " + esc(p.name) + "</strong> " + esc(p.size) + (vl ? " · " + esc(vl) : "")));
        var rs = t(p.reason);
        if (rs) card.appendChild(el("p", "mxq-p", esc(rs)));
        card.appendChild(el("div", "mxq-freq", esc(t(UI().freqLabel)) + "：<strong>" + esc(t(p.frequency)) + "</strong>"));
        rt.appendChild(card);
      });
      page.appendChild(rt);

      /* 4 周计划 */
      if (CFG.COPY.weekPlan && CFG.COPY.weekPlan.length) {
        var wp = el("div", "mxq-print-sec");
        wp.appendChild(el("h2", "mxq-print-h", "<span class=\"mxq-secno\">05</span>" + esc(t(UI().printPlanTitle))));
        CFG.COPY.weekPlan.forEach(function (w) {
          var row = el("div", "mxq-print-week");
          row.appendChild(el("div", "mxq-print-week-label", esc(t(w.week))));
          row.appendChild(el("p", "mxq-p", esc(t(w.text))));
          wp.appendChild(row);
        });
        page.appendChild(wp);
      }

      /* 页脚 */
      page.appendChild(el("div", "mxq-print-footer", esc(t(UI().printFooter))));

      mount.appendChild(page);
    }

    function addItemsToCart(variantIds) {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: variantIds.map(function (variantId) {
            return { id: Number(variantId), quantity: 1 };
          })
        })
      }).then(function (res) { return res.ok; }).catch(function () { return false; });
    }

    function addToCart(variantId) {
      return addItemsToCart([variantId]);
    }

    /* ---------- 进场: 检查 ?r= ---------- */
    var rParam = params.get("r");
    if (rParam) {
      var decoded = E.decodeAnswers(rParam);
      if (decoded) {
        state.answers = decoded;
        state.report = E.buildReport(decoded);
        if (params.get("print") === "1") {
          renderPrint(state.report);
        } else {
          renderReport();
        }
        return;
      }
      try { history.replaceState(null, "", analysisBaseUrl()); } catch (e) {}
    }
    renderIntro();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  if (typeof module !== "undefined" && module.exports) {
    module.exports = { _test: true };
  }
})(typeof window !== "undefined" ? window : globalThis);
